import React from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import StudentLayout from "../page/Student/StudentLayout"
import StudentPlaceholderPage from "../page/Student/StudentPlaceholderPage"
import DashboardPage from "../page/Student/Dashboard/DashboardPage"
import QuestionsPage from "../page/Student/Questions/QuestionsPage"
import BookmarksPage from "../page/Student/Bookmarks/BookmarksPage"
import NotesPage from "../page/Student/Notes/NotesPage"
import PracticePapersPage from "../page/Student/PracticePapers/PracticePapersPage"
import PracticePaperAnalyticPage from "../page/Student/PracticePapers/PracticePaperAnalyticPage"
import AiAssessorPage from "../page/Student/AiAssessor/AiAssessorPage"
import PaperAssessorPage from "../page/Student/AiAssessor/PaperAssessorPage"
import { LEARNER_DEFAULT_PATH } from "../auth/learner/constants"

/**
 * Nested under `/learner/*` — page paths are relative to the splat.
 * Redirects must be absolute so catch-alls never append segments
 * (e.g. /learner/login → /learner/login/dashboard/dashboard/…).
 */
const StudentRoutes = () => {
  return (
    <Routes>
      <Route element={<StudentLayout />}>
        <Route
          index
          element={<Navigate to={LEARNER_DEFAULT_PATH} replace />}
        />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="questions" element={<QuestionsPage />} />
        <Route path="practice-papers" element={<PracticePapersPage />} />
        <Route
          path="practice-papers/:paperId/analytic"
          element={<PracticePaperAnalyticPage />}
        />
        <Route path="ai-assessor" element={<AiAssessorPage />} />
        <Route path="ai-assessor/:paperId" element={<PaperAssessorPage />} />
        <Route path="bookmarks" element={<BookmarksPage />} />
        <Route path="notes" element={<NotesPage />} />
        <Route path="profile" element={<StudentPlaceholderPage />} />
        <Route
          path="*"
          element={<Navigate to={LEARNER_DEFAULT_PATH} replace />}
        />
      </Route>
    </Routes>
  )
}

export default StudentRoutes
